import { useState, useRef, useEffect } from "react";
import { useLang } from "@/context/LangContext";
import { Globe, Check, ChevronDown } from "lucide-react";

export default function LanguageSwitcher({ dark = false }) {
  const { lang, setLang, meta } = useLang();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);

  return (
    <div className="relative" ref={ref}>
      <button
        onClick={() => setOpen((v) => !v)}
        data-testid="lang-switcher-toggle"
        className={`flex items-center gap-1 px-2 py-1 rounded text-xs font-bold uppercase tracking-widest hover:text-[var(--accent)] transition-colors ${dark ? "text-white/80" : "text-[var(--ink)]"}`}
        aria-label="Change language"
      >
        <Globe size={14} />
        <span>{meta[lang].flag}</span>
        <span>{lang.toUpperCase()}</span>
        <ChevronDown size={12} className={`transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="absolute right-0 mt-2 w-40 bg-white border border-black/10 rounded shadow-lg overflow-hidden z-50" data-testid="lang-switcher-menu">
          {Object.entries(meta).map(([k, m]) => (
            <button
              key={k}
              onClick={() => { setLang(k); setOpen(false); }}
              data-testid={`lang-option-${k}`}
              className={`w-full flex items-center justify-between px-3 py-2 text-sm hover:bg-[var(--bg-soft)] ${lang === k ? "text-[var(--accent)] font-bold" : "text-[var(--ink)]"}`}
            >
              <span className="flex items-center gap-2"><span>{m.flag}</span> {m.label}</span>
              {lang === k && <Check size={14} />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
